




import { Component, Vue } from "vue-property-decorator";
import Documentation from "@/components/Documentation.vue"; // @ is an alias to /src

@Component({
  components: {
    Documentation
  }
})
export default class DocumentationPage extends Vue {}
